import * as React from 'react';
import clsx from 'clsx';
import { VoiceButton } from './VoiceButton';
import { ChatInputShell } from './ChatInputShell';

interface MockChatInputProps {
  className?: string;
}

/**
 * Purely presentational chat-input clone used on the auth screen preview.
 * No state, no recorder — just the shared `ChatInputShell` chrome with a
 * static placeholder + disabled `VoiceButton`.
 */
export const MockChatInput: React.FC<MockChatInputProps> = ({ className }) => (
  <ChatInputShell
    {...(className !== undefined ? { className } : {})}
    disclaimer={
      <p
        className={clsx(
          'mt-3 text-center font-sans text-10 font-medium leading-160 tracking-[-0.02em]',
          'text-white/40 xl:text-11'
        )}
      >
        Echoes can make mistakes. Check important info. See{' '}
        <span className='cursor-pointer underline decoration-solid decoration-auto hover:text-white/60'>
          Echoes Details
        </span>
        .
      </p>
    }
  >
    <div className='flex size-full items-center pl-[30px] pr-[120px]'>
      <span className='font-sans text-16 font-medium leading-160 tracking-[-0.02em] text-white/50'>
        Enter Message
      </span>
    </div>
    <VoiceButton disabled />
  </ChatInputShell>
);

MockChatInput.displayName = 'MockChatInput';
